import {schema as textInputWidgetSchema} from "./TextInputWidget";

export function type() {
    return 'subtitle_input';
}

/**
 * liest den Wert aus der Paper Submission aus und gibt ihn zurück
 * Das wird benötigt, um die Form zu initialisieren
 * @param callForPapers
 * @param widget
 * @param submission
 * @returns {*}
 */
export function submissionValue(callForPapers, widget, submission) {
    return submission.subTitle
}

export function schema(widget, allowPartialSubmissions) {
    const schema = textInputWidgetSchema(widget)
    return schema.required()
}

// Wir benutzen das TextInputWidget
export {component, initialValue} from '../widget/TextInputWidget'